<nz-result
  class="center"
  nzStatus="info"
  [nzIcon]="'lock'"
  nzTitle="Premium Feature"
  [nzSubTitle]="'This feature is only available in the Premium plan.'"
>
  <div nz-result-extra>
    <button nz-button nzType="primary" [nzSize]="'large'" (click)="onUpgradeClick()">Upgrade</button>
  </div>
</nz-result>
